import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-normalLogol",
  "use": "icon-normalLogol-usage",
  "viewBox": "0 0 20 19.998",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 19.998\" id=\"icon-normalLogol\"><path data-name=\"减去 22\" d=\"M13.998 19.998h-8a6.008 6.008 0 0 1-6-6v-8a6 6 0 0 1 6-6h8a6.006 6.006 0 0 1 6 6v8a6.01 6.01 0 0 1-6 6zM5.289 9.016L4 10.053l5.029 5.123A31 31 0 0 1 16 5.531l-.311-.709a32.507 32.507 0 0 0-7.488 6.479z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol